import { render, staticRenderFns } from "./BookingMessageForm.vue?vue&type=template&id=74b87ced"
import script from "./BookingMessageForm.vue?vue&type=script&lang=js"
export * from "./BookingMessageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports